import { IDropDownArrow } from '../../shared-interfaces/IDropDownArrow';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import * as React from 'react';

const DropDownArrow = (props: IDropDownArrow) => {
  return props.up ? (
    <ArrowDropUpIcon fontSize="small" />
  ) : (
    <ArrowDropDownIcon fontSize="small" />
  );
};

export default DropDownArrow;
